<!-- OrderConfirmAddress -->
<template>
  <div class="logistics cardPart" @click="addressSelect">
    <p :class="['userInfo', { 'userInfoEmpty': !addressInfo.id }]">
      <span class="userName ellipsis">{{addressInfo.id ? addressInfo.userName : '请添加材料的寄送地址'}}</span>
      <span class="userPhone">{{addressInfo.id && addressInfo.phone || ''}}</span>
    </p>
    <p v-if="addressInfo.id" class="addressInfo">{{addressInfo.province + addressInfo.city + addressInfo.area + addressInfo.address}}</p>
  </div>
</template>

<script>
export default {
  props: {
    addressInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    addressSelect() {
      this.$emit('click');
    },
  },
};

</script>
<style lang="scss" scoped>
.logistics {
  position: relative;
  margin-bottom: 29px;
  padding: 25px 70px 29px 36px;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;

  .userInfo {
    display: flex;
    height: 36px;
    margin-bottom: 14px;
    padding-left: 43px;
    font-size: 25px;
    line-height: 36px;
    background: url('../../../assets/img/payment/address.png') no-repeat left 1px;
    background-size: 29px 29px;

    .userName {
      display: inline-block;
      max-width: 300px;
      margin-right: 29px;
      font-weight: bold;
    }

    &.userInfoEmpty {
      margin-bottom: 0;
      color: #333;
      font-weight: 500;
      font-size: 25px;
      line-height: 36px;
      background-image: url('../../../assets/img/payment/address_empty.png');
    }
  }

  .addressInfo {
    max-width: 600px;
    overflow: hidden;
    color: #787878;
    font-size: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &::after {
    position: absolute;
    top: 50%;
    right: 20px;
    width: 43px;
    height: 43px;
    background: url('../../../assets/img/payment/go_detail.png') no-repeat center;
    background-size: contain;
    transform: translateY(-50%);
    content: '';
  }
}
</style>
